module.exports = __webpack_public_path__ + "img/[白眼].51870567.svg";